// Footer.jsx
import React, { useEffect, useState } from 'react';

// Services
import { getImportDate } from '@/services/schedulingService';

// Styling

const Footer = ({ timeout }) => {
  const [importDate, setImportDate] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const importDate = await getImportDate();
        setImportDate(importDate);
      } catch (error) {
        console.error('Error fetching allocations data:', error);
        setImportDate(null);
      }
    }
    fetchData();
  }, []);

  const formatDate = dateString => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <footer className='workspace-footer'>
      <span>Scheduling · Resource planning</span>
      <span>
        {importDate ? `Last import: ${importDate}` : 'Import date unavailable'}
        {timeout ? ` · Session expires ${formatDate(timeout)}` : ''}
      </span>
    </footer>
  );
};

export default Footer;
